var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    { attrs: { flat: "" } },
    [
      _c(
        "v-card-title",
        [
          _c("h3", { staticClass: "headline mb-0 admin-header" }, [
            _vm._v("Collector Logs"),
          ]),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              attrs: {
                text: "",
                icon: "",
                color: "grey lighten-1",
                loading: _vm.loadingCollectors || _vm.loading,
              },
              on: { click: _vm.refresh },
            },
            [_c("v-icon", [_vm._v("fas fa-sync")])],
            1
          ),
          _vm._v(" "),
          _c("v-select", {
            attrs: {
              items: _vm.allCollectors,
              "item-text": "id",
              "item-value": "id",
              label: "Source Collector",
            },
            model: {
              value: _vm.selectedCollectorId,
              callback: function ($$v) {
                _vm.selectedCollectorId = $$v
              },
              expression: "selectedCollectorId",
            },
          }),
          _vm._v(" "),
          _c("v-spacer"),
          _vm._v(" "),
          _c("v-text-field", {
            attrs: {
              "append-icon": "fal fa-search",
              placeholder: "Search",
              "single-line": "",
              "hide-details": "",
              clearable: "",
            },
            model: {
              value: _vm.search,
              callback: function ($$v) {
                _vm.search = $$v
              },
              expression: "search",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("v-data-table", {
        staticClass: "elevation-1",
        attrs: {
          items: _vm.filteredLogs(),
          search: _vm.search,
          loading: _vm.loading,
          headers: _vm.headers,
          "footer-props": { "items-per-page-options": _vm.numRowsPerPage },
          options: _vm.pagination,
        },
        on: {
          "update:options": function ($event) {
            _vm.pagination = $event
          },
        },
        scopedSlots: _vm._u([
          {
            key: "item.dateTime",
            fn: function ({ item }) {
              return [
                _c("td", [_vm._v(_vm._s(_vm.formatDateTime(item.dateTime)))]),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }